import { render, staticRenderFns } from "./FeedBrands.vue?vue&type=template&id=d2b594ee&"
import script from "./FeedBrands.vue?vue&type=script&lang=js&"
export * from "./FeedBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports